import { Helmet } from "react-helmet-async";

const DEFAULT_DESCRIPTION =
  "HerVest | Pioneering inclusive finance for the African woman.";

// Only per-page tags live here. Static tags (viewport, robots, theme-color,
// owner, ...) are in public/index.html — repeating them through Helmet made
// it add/remove dozens of head nodes on every route change.
const SEO = ({ title, description }) => {
  const desc = description || DEFAULT_DESCRIPTION;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={desc} />
      <meta
        name="keywords"
        content="HerVest, saving in Nigeria, Investment in Nigeria, Female Finance, Cliq Saving, fintech, nigeria fintech, loans"
      />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={window.location.origin} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={desc} />
      <link rel="canonical" href={window.location.origin} />
    </Helmet>
  );
};

export default SEO;
